"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportedFiatCurrenciesList = void 0;
/**
 * stackedQ: We need the list in the frontend,
 * and there's no way to convert an union type to an array,
 * so the list is defined as an array of strings,
 * but SupportedFiatCurrencies is an union of strings
 */
exports.SupportedFiatCurrenciesList = Object.freeze([
    'CNY',
    'USD',
    'EUR',
    'JPY',
    'GBP',
    'KRW',
    'INR',
    'CAD',
    'HKD',
    'AUD',
    'TWD',
    'BRL',
    'CHF',
    'THB',
    'MXN',
    'RUB',
    'SAR',
    'SGD',
    'ILS',
    'IDR',
]);
